export const featureList = {
  POLL: "Poll",
  FORUM: "Forum",
  CERTIFICATE: "Certificate",
  LIVE_QUIZ: "LiveQuizzing",
  VIRTUAL_QUIZ: "VirtualQuizzing",
  My_QUERY: "Learner Query",
  EMAIL_TRIGGER: "EmailTrigger",
  TOPIC_MGMT: "Topic",
  ENGAGEMENT_CENTER: "CustomPushNotification",
  EMAIL_REMINDER: "EmailRemainder",
  LANGUAGE_VARIANT: "LanguageVariant",
  OFFLINE_FEATURE_FOR_SHOTCLASS: "Offline",
  MODERATE_CONTRIBUTION: "ShotclassesCrowdSourcing",
  MANAGE_TRANSCRIPTION: "SemanticSearch",
  SLIDE_SHARE: "SlideShare",
};
